import { List, Map } from 'immutable';
import { defaults, isFunction, keys, reduce, some } from 'lodash';

export interface IChangeField {
  key: string;
  value: any;
}

export function merger(a, b) {
  if (b !== null && a && a.mergeWith && !List.isList(a) && !List.isList(b)) {
    return a.mergeWith(merger, b);
  }

  return b;
}

export function serialize(model: any) {
  const isImmutable = !!(model && model.asImmutable);

  if (isImmutable) {
    return serializeHelper(
      (model.serialize ? model.serialize() : model).asMutable()
    );
  }

  return isImmutable ? model.asImmutable() : model;
}

function serializeHelper(model: Map<string, any>): Map<string, any> {
  return model.map((value) => {
    if (value && value.asImmutable) {
      if (List.isList(value)) {
        return value.map((v) => serialize(v));
      } else {
        return serialize(value);
      }
    } else {
      return value;
    }
  }) as Map<string, any>;
}

export function decorateWithKeys(model: any, modelKeys: any) {
  return defaults(model, modelKeys);
}

export function setInModel(model: Map<string, any>, changes: IChangeField[]) {
  return model.withMutations((map) => {
    changes.forEach((change: IChangeField) =>
      map.set(change.key, change.value)
    );
  });
}

export function hasValue(
  keysToCheck: any,
  defaultValues: any,
  currentValues: Map<String, any>
) {
  return some(defaultValues, (value: any, key: string) => {
    const currentValue = currentValues.get(keysToCheck[key]);

    return !isFunction(value) && currentValue && currentValue !== value;
  });
}

export function generateKeys(schema: any) {
  return reduce(
    keys(schema),
    (obj, key: any) => {
      obj[key] = key.toLowerCase();

      return obj;
    },
    {}
  );
}

export function generateSchema(schema: any) {
  return reduce(
    keys(schema),
    (obj, key: any) => {
      // tsc was returning error: Cannot use 'new' with an expression whose type lacks a call or construct signature.
      // if I tried to put `schema[ key ]` in a variable first. I've tried to cast it as an `any` but it still errored
      // out.
      try {
        // `schema[ key ]` sometimes is a class that we want to instantiate, but due to above issue,
        // we need to have this `try-catch` statement instead of a `isFunction` check
        obj[key.toLowerCase()] = new schema[key]();
      } catch (e) {
        obj[key.toLowerCase()] = schema[key];
      }

      return obj;
    },
    {}
  );
}
